import { render, staticRenderFns } from "./partida-avance-info.vue?vue&type=template&id=78746c14&scoped=true&"
import script from "./partida-avance-info.vue?vue&type=script&lang=js&"
export * from "./partida-avance-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78746c14",
  null
  
)

export default component.exports